import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: 'sortBy',
    standalone: false
})

export class ArraySortPipe  implements PipeTransform {
  transform(array: [], field: string):  unknown[] {
    array.sort((a, b) => {
      if (a[field] < b[field]) {
        return -1;
      } else if (a[field] > b[field]) {
        return 1;
      } else {
        return 0;
      }
    });
    return array;
  }
}

/**
 * Sort Factory generic
 * @param field : string
 * @returns array sort by field
 */
export const sortFactoryByField = function<T>(field: keyof T ) : (a: T, b: T) => number {
  return (a : T, b: T) => {
      if (a[field] < b[field]) {
        return -1;
      } else if (a[field] > b[field]) {
        return 1;
      } else {
        return 0;
      }
    };
};
